import styled from 'styled-components';
import {IoIosUmbrella} from 'react-icons/io';

export const IoUmbrella = styled(IoIosUmbrella)`
  color: #EC0899;
`
